/**
 *   Created by Arif Topcu in 2018
 */
import React, {useCallback} from 'react';
import Switch from '@ls/react-switch';
import {useDispatch, useSelector} from 'react-redux';
import { selectSelectedIsDefaultBenchmark } from 'state/selections/selectors';
import SelectionState from 'state/selections/SelectionState';
import { setSelectedIsDefaultBenchmark } from 'state/selections/actions';

const DefaultBenchmarkSwitch = () => {
  const isDefaultBenchmark = useSelector(selectSelectedIsDefaultBenchmark(SelectionState.UNCOMMITTED));
  const dispatch = useDispatch();

  const onChange = useCallback(() => {
    dispatch(setSelectedIsDefaultBenchmark(!isDefaultBenchmark));
  }, [dispatch, isDefaultBenchmark]);
  return (
    <Switch
      label="Use Default Benchmark"
      value={isDefaultBenchmark}
      onChange={onChange}
      raised
    />
  );
};

export default DefaultBenchmarkSwitch;
